export const MonitoringDashboardResourcesBS: MonitoringDashboardResourcesInterface =
  {
    title: "Monitoring Dashboard",
    danasTitle: (count: number) => `Danas (${count})`,
    kasniTitle: (count: number) => `Kasni (${count})`,
    uradjenoTitle: (count: number) => `Urađeno (${count})`,
    cardsPlaceholder: "Nema zadataka",
    errorCards: "Greška pri učitavanju kartica",
    errorDone: "Greška pri učitavanju završenih zadataka",
    loading: "Učitavanje podataka...",
    previous: "Prethodno",
    next: "Sljedeće",
    branchPlaceholder: "Odaberi poslovnicu",
    branchNotFound: "Ni jedna poslovnica nije pronađena",
    allBranches: "Sve poslovnice",
    autoRefreshDisabled: "Auto-refresh isključen",
    autoRefresh1Min: "1 minuta",
    autoRefresh3Min: "3 minute",
    autoRefresh5Min: "5 minuta",
    autoRefresh10Min: "10 minuta",
    autoRefresh15Min: "15 minuta",
    autoRefresh20Min: "20 minuta",
    autoRefresh30Min: "30 minuta",
    autoRefresh45Min: "45 minuta",
    autoRefresh60Min: "60 minuta",
    refresh: "Osvježi",
    accessDeniedTitle: "Nemate pristup",
    accessDeniedMessage:
      "Monitoring Dashboard mogu vidjeti samo menadžeri i šefovi objekata. Dodavanje na objekt omogućava Planirane zadatke, ali ne i ovaj pregled.",
  };

export const MonitoringDashboardResourcesEN: MonitoringDashboardResourcesInterface =
  {
    title: "Monitoring Dashboard",
    danasTitle: (count: number) => `Today (${count})`,
    kasniTitle: (count: number) => `Late (${count})`,
    uradjenoTitle: (count: number) => `Done (${count})`,
    cardsPlaceholder: "No tasks",
    errorCards: "Error loading cards",
    errorDone: "Error loading completed tasks",
    loading: "Loading data...",
    previous: "Previous",
    next: "Next",
    branchPlaceholder: "Select branch",
    branchNotFound: "No branch found",
    allBranches: "All branches",
    autoRefreshDisabled: "Auto-refresh disabled",
    autoRefresh1Min: "1 minute",
    autoRefresh3Min: "3 minutes",
    autoRefresh5Min: "5 minutes",
    autoRefresh10Min: "10 minutes",
    autoRefresh15Min: "15 minutes",
    autoRefresh20Min: "20 minutes",
    autoRefresh30Min: "30 minutes",
    autoRefresh45Min: "45 minutes",
    autoRefresh60Min: "60 minutes",
    refresh: "Refresh",
    accessDeniedTitle: "Access denied",
    accessDeniedMessage:
      "Only branch managers and company chiefs can view the Monitoring Dashboard. Being added to a branch enables Planned tasks, but not this overview.",
  };

export const MonitoringDashboardResourcesDE: MonitoringDashboardResourcesInterface =
  {
    title: "Monitoring Dashboard",
    danasTitle: (count: number) => `Heute (${count})`,
    kasniTitle: (count: number) => `Verspätet (${count})`,
    uradjenoTitle: (count: number) => `Erledigt (${count})`,
    cardsPlaceholder: "Keine Aufgaben",
    errorCards: "Fehler beim Laden der Karten",
    errorDone: "Fehler beim Laden der abgeschlossenen Aufgaben",
    loading: "Daten werden geladen...",
    previous: "Vorherige",
    next: "Nächste",
    branchPlaceholder: "Filiale auswählen",
    branchNotFound: "Keine Filiale gefunden",
    allBranches: "Alle Filialen",
    autoRefreshDisabled: "Auto-Aktualisierung deaktiviert",
    autoRefresh1Min: "1 Minute",
    autoRefresh3Min: "3 Minuten",
    autoRefresh5Min: "5 Minuten",
    autoRefresh10Min: "10 Minuten",
    autoRefresh15Min: "15 Minuten",
    autoRefresh20Min: "20 Minuten",
    autoRefresh30Min: "30 Minuten",
    autoRefresh45Min: "45 Minuten",
    autoRefresh60Min: "60 Minuten",
    refresh: "Aktualisieren",
    accessDeniedTitle: "Kein Zugriff",
    accessDeniedMessage:
      "Das Monitoring-Dashboard können nur Filialleiter und Unternehmenschefs einsehen. Die Zuweisung zu einer Filiale aktiviert geplante Aufgaben, aber nicht diese Übersicht.",
  };

export interface MonitoringDashboardResourcesInterface {
  title: string;
  danasTitle: (count: number) => string;
  kasniTitle: (count: number) => string;
  uradjenoTitle: (count: number) => string;
  cardsPlaceholder: string;
  errorCards: string;
  errorDone: string;
  loading: string;
  previous: string;
  next: string;
  branchPlaceholder: string;
  branchNotFound: string;
  allBranches: string;
  autoRefreshDisabled: string;
  autoRefresh1Min: string;
  autoRefresh3Min: string;
  autoRefresh5Min: string;
  autoRefresh10Min: string;
  autoRefresh15Min: string;
  autoRefresh20Min: string;
  autoRefresh30Min: string;
  autoRefresh45Min: string;
  autoRefresh60Min: string;
  refresh?: string;
  accessDeniedTitle: string;
  accessDeniedMessage: string;
}

